import { sc } from '@/utils/storage'
import { INSIDE_APPID, PROMOTE_CODE } from '@/utils/storage-const'

export function checkPromote(to) {
  try {
    const currentRoute = to
    const { query } = currentRoute
    const promote_code = query?.promote_code
    if (promote_code) {
      sc(PROMOTE_CODE, promote_code)
    }
  } catch (e) {
    console.log(e)
  }
}

export function checkMiniEnv(to) {
  try {
    const currentRoute = to
    const { query } = currentRoute
    const insideAppId = query?.insideAppId
    if (insideAppId) {
      sc(INSIDE_APPID, insideAppId)
    }
  } catch (e) {
    console.log(e)
  }
}
import { mapState } from 'vuex'
export const homeLeftRightBtnMixins = {
  computed: {
    ...mapState({
      userInfo: (state) => state.user.info
    }),
    rightBtnFont() {
      if (this.userInfo) return '合作进度'
      return 'KOL入驻'
    }
  },
  methods: {
    rightBtnClick() {
      this.$emit('rightBtnClick')
    }
  }
}
